import { PROJECT_FILES_TAG } from '@/api/constants';
import { api } from '@/api/core';
import { getMockSavedDraftVersionIds } from './mockProjectFiles';
import { mockDelay } from './mockUtils';

export interface GetSavedChatArtefactsRequest {
  projectId: string;
}

/** Shape assumed until the backend contract exists */
export interface GetSavedChatArtefactsResponse {
  /** Chat drafts already saved to the project as files. */
  draftVersionIds: string[];
}

const MOCK_RESPONSE_DELAY_MS = 200;

export const getSavedChatArtefactsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSavedChatArtefacts: builder.query<GetSavedChatArtefactsResponse, GetSavedChatArtefactsRequest>({
      // The backend endpoint does not exist yet: read the mock file list (see mockProjectFiles.ts).
      queryFn: async ({ projectId }) => {
        await mockDelay(MOCK_RESPONSE_DELAY_MS);
        const draftVersionIds = getMockSavedDraftVersionIds(projectId);

        return draftVersionIds ? { data: { draftVersionIds } } : { error: { status: 404, data: 'Project not found' } };
      },
      // Saving or deleting project files changes which drafts count as saved.
      providesTags: (_result, _error, { projectId }) => [{ type: PROJECT_FILES_TAG, id: projectId }],
    }),
  }),
});

export const { useGetSavedChatArtefactsQuery } = getSavedChatArtefactsApi;
